import * as buttons from 'smg/buttons';
import * as session from 'smg/customer-api/session';
// import * as template from 'smg/template';

import axios, { AxiosStatusCode } from 'smg/axios';
import { ReportValidity } from 'smg/form';
import { G } from 'smg/querystring';

import { Relref } from '../hugo';
import { HandleRequestError } from 'smg/errors';

if (document.body.id === 'reset-password') {
    main();
}

declare interface useResponse {
    token: string;
}

function main() {
    const $spinner = document.querySelector<HTMLElement>('#reset-password-spinner-container') as HTMLElement;
    const $form = document.querySelector<HTMLFormElement>('#reset-password-form') as HTMLFormElement;
    const $alert = $form.querySelector<HTMLElement>('#invalid-link-alert') as HTMLElement;
    const $input1 = $form.querySelector<HTMLInputElement>('#reset-password-1') as HTMLInputElement;
    const $input2 = $form.querySelector<HTMLInputElement>('#reset-password-2') as HTMLInputElement;
    const $submit = $form.querySelector<HTMLButtonElement>('[type="submit"]') as HTMLButtonElement;

    const key = G().Get('id') ?? '';

    [$input1, $input2].forEach($input => {
        $input.addEventListener('input', () => {
            $alert.classList.add('d-none');
        });
    });

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        $input2.setCustomValidity('');
        if ($input1.value !== $input2.value) {
            $input2.setCustomValidity('Passwords do not match');
        }

        if (!ReportValidity($form)) {
            return false;
        }

        buttons.Start($submit);

        await axios.patch<useResponse>(`/password-resets/${key}/used`, {
            'password': $input1.value,
            'confirmPassword': $input2.value,
        }).then(resp => {
            $alert.classList.add('d-none');
            session.SetLoginToken(resp.data.token);
            window.location.href = Relref('/account');
        }).catch(err => {
            switch (AxiosStatusCode(err)) {
            case 404:
            case 403:
            case 400:
                $alert.classList.remove('d-none');
                break;
            default:
                HandleRequestError(err, $form);
            }
        }).finally(() => {
            buttons.Stop($submit);
        });
    });

    setTimeout(() => $spinner.classList.add('d-none'));
}
